import constant from "../../constant";
const resource = constant.api + "customers";

const state = {
  customers: [],
  customer: {},
};

// getters
const getters = {
  getAll: (state) => {
    return state.customers;
  },
  getCustomer: (state) => {
    return state.customer;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    const data = await this._vm.$api.fetch(resource);
    commit("setAll", data);
    return data;
  },

  async show({ commit }, reference) {
    const response = await this._vm.$api.show(`${resource}/${reference}`);
    // Extract data from response - handle both nested and direct responses
    let data = null;
    if (response && typeof response === "object") {
      if (response.data) {
        // If response has a data property, use it
        data = response.data;
      } else if (Array.isArray(response)) {
        // If response is an array, use first element
        data = response[0] || response;
      } else {
        // Otherwise use response directly
        data = response;
      }
    }
    commit("setCustomer", data);
    return data;
  },

  async store({ dispatch }, data) {
    const response = await this._vm.$api.create(resource, data);
    await dispatch("getAll");
    return response;
  },

  async update({ dispatch }, { reference, data }) {
    console.log("Customer update action called:", { reference, data });
    try {
      const response = await this._vm.$api.update(
        `${resource}/${reference}`,
        data
      );
      console.log("Customer update response:", response);
      await dispatch("show", reference);
      return response;
    } catch (error) {
      console.error("Error in customer update action:", error);
      throw error;
    }
  },

  async destroy({ dispatch }, reference) {
    const response = await this._vm.$api.delete(`${resource}/${reference}`);
    await dispatch("getAll");
    return response;
  },

  async reset({ commit }) {
    commit("resetCustomer");
  },
};

// mutations
const mutations = {
  setAll(state, data) {
    state.customers = Array.isArray(data) ? data : data?.data || [];
  },

  setCustomer(state, data) {
    // Ensure we store the customer object directly
    if (!data) {
      state.customer = {};
      return;
    }
    // If data has a data property, use it (for nested responses)
    if (
      data.data &&
      typeof data.data === "object" &&
      !Array.isArray(data.data)
    ) {
      state.customer = data.data;
    } else if (typeof data === "object" && !Array.isArray(data)) {
      // Use data directly if it's an object
      state.customer = data;
    } else {
      state.customer = {};
    }
  },

  resetCustomer(state) {
    state.customer = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
